export default [
  {
    path: '/biglietteria/importa-tracciati-biglietteria',
    name: 'importa-tracciati-biglietteria',
    component: () => import('@/views/biglietteria/PaginaImportaTracciatiBiglietteria.vue'),
    meta: {
      resource: 'biglietteria-full',
      action: 'read',
      breadcrumb: [
        {
          text: 'Biglietteria',
        },
        {
          text: 'Importazione Tracciati',
          active: true,
        },
      ],
    },
  },
  {
    path: '/biglietteria/importa-utenti-biglietteria',
    name: 'importa-utenti-biglietteria',
    component: () => import('@/views/biglietteria/PaginaImportaUtentiBiglietteria.vue'),
    meta: {
      resource: 'biglietteria-full',
      action: 'read',
      breadcrumb: [
        {
          text: 'Biglietteria',
        },
        {
          text: 'Importazione Utenti',
          active: true,
        },
      ],
    },
  },
  {
    path: '/biglietteria/chart-biglietteria',
    name: 'chart-biglietteria',
    component: () => import('@/views/biglietteria/PaginaChartBiglietteria.vue'),
    meta: {
      resource: 'biglietteria-full',
      action: 'read',
      breadcrumb: [
        {
          text: 'Biglietteria',
        },
        {
          text: 'Chart Biglietteria',
          active: true,
        },
      ],
    },
  },
  {
    path: '/biglietteria/tracciati-biglietteria',
    name: 'tracciati-biglietteria',
    component: () => import('@/views/biglietteria/PaginaVisualizzaTracciatiBiglietteria.vue'),
    meta: {
      resource: 'biglietteria-full',
      action: 'read',
      breadcrumb: [
        {
          text: 'Biglietteria',
        },
        {
          text: 'Tracciati Biglietteria',
          active: true,
        },
      ],
    },
  },
  {
    path: '/biglietteria/riepilogo-incassi-biglietteria',
    name: 'riepilogo-incassi-biglietteria',
    component: () => import('@/views/biglietteria/PaginaRiepilogoIncassiBiglietteria.vue'),
    meta: {
      resource: 'biglietteria-full',
      action: 'read',
      breadcrumb: [
        {
          text: 'Biglietteria',
        },
        {
          text: 'Incassi Biglietteria',
          active: true,
        },
      ],
    },
  },
  {
    path: '/biglietteria/statistiche-scritture',
    name: 'statistiche-scritture',
    component: () => import('@/views/biglietteria/PaginaStatisticheScritture.vue'),
    meta: {
      resource: 'biglietteria-full',
      action: 'read',
      breadcrumb: [
        {
          text: 'Biglietteria',
        },
        {
          text: 'Statistiche scritture',
          active: true,
        },
      ],
    },
  },
]
